export const RECORDS_EDIT_PERMISSION = 'ui-eholdings.records.edit';

export const TITLES_PACKAGES_CREATE_DELETE_PERMISSION = 'ui-eholdings.titles-packages.create-delete.manage';

export const PACKAGE_TITLE_SELECT_UNSELECT_PERMISSION = 'ui-eholdings.package-title.select-unselect.execute';
